import { AdvancedSettingsMap, AIRunModel, ModelDependency, TrainedModel } from "../../@shared/Models/Models";
import { ModelType } from "../../@shared/Models/ModelTypes";

export const initialModel = {
    isShowModal: false as boolean,
    isShowRunModal: false as boolean,
    isDuplicateModal: false as boolean,
    isShowOnnxModal: false as boolean,
    onnxModalTrainerId: "" as string,
    onnxUploadProgress: 0 as number,
    isOnnxUploading: false as boolean,
    name: "" as string,
    description: "" as string,
    settings: "" as string,
    runData: "" as string,
    schemaOrdering: "" as string,
    schemaOrderingResult: "" as string,
    runResult: {} as AIRunModel,
    aiModelId: "" as string,
    duplicateModelId: "" as string,
    testPercent: 0.3 as number,
    advancedSettingsMap: {} as AdvancedSettingsMap,
    aiModelTrainerTypeId: undefined as ModelType | undefined,
    aiModelTrainedModelId: undefined as string | undefined,
    openedModel: undefined as TrainedModel | undefined,
    isLoadingResults: false as boolean,
    isUpdating: false as boolean,
    isShowCalculateMetricsModal: false as boolean,
    modelDependencies: [] as ModelDependency[],
}

export const initialState = {
    trainedModel: initialModel,
}

export type TrainedModelStateType = typeof initialState;

